import * as PropertyType from 'modules/property_type/components/Reference'

export { PropertyType }
